import type { FC } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Yes, I'm sure",
  cancelText = "No, cancel",
  isLoading = false,
}) => {
  return (
    <Modal onClose={onClose} show={isOpen} size="md">
      <ModalHeader className="px-6 pb-0 pt-6">
        <span className="sr-only">{title}</span>
      </ModalHeader>
      <ModalBody className="px-6 pb-6 pt-0">
        <div className="flex flex-col items-center gap-y-6 text-center">
          <HiOutlineExclamationCircle className="text-7xl text-red-500" />
          <p className="text-xl text-gray-500">{message}</p>
          <div className="flex items-center gap-x-3">
            <Button color="failure" onClick={onConfirm} disabled={isLoading}>
              {isLoading ? "Deleting..." : confirmText}
            </Button>
            <Button color="light" onClick={onClose} disabled={isLoading}>
              {cancelText}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationModal;
